import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { from, Observable } from 'rxjs';
import { BiometricsAvailable, FingerprintService } from '../service/fingerprint.service';

@Component({
  selector: 'app-biometric-activator',
  templateUrl: './biometric-activator.page.html',
  styleUrls: ['./biometric-activator.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BiometricActivator {

  biometrics$: Observable<BiometricsAvailable>;

  constructor(
    private navCntrl: NavController,
    private route: ActivatedRoute,
    private fingerprintService: FingerprintService
  ) {
    this.biometrics$ = from(this.fingerprintService.retrieveDeviceBiometrics());
  }

  close() {
    const callbackUrl = this.route.snapshot.queryParamMap.get('callbackUrl');
    this.navCntrl.navigateForward(callbackUrl);
  }

  activateFaceID() {
    const callbackUrl = this.route.snapshot.queryParamMap.get('callbackUrl');
    const password = this.route.snapshot.queryParamMap.get('password');
    const user = this.route.snapshot.queryParamMap.get('user');
    this.fingerprintService.activateFaceID(user, password).then(() => {
      this.navCntrl.navigateForward(callbackUrl);
    })
  }

  activateTouchID() {
    const callbackUrl = this.route.snapshot.queryParamMap.get('callbackUrl');
    const password = this.route.snapshot.queryParamMap.get('password');
    const user = this.route.snapshot.queryParamMap.get('user');
    this.fingerprintService.activateTouchID(user, password).then(() => {
      this.navCntrl.navigateForward(callbackUrl);
    })
  }
}